'use client';

import React, { FC } from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Button from '@/components/Button/Button';
import { Container } from '@/components/Container';
import background from '@/public/features/scheduling/background.webp';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';
import { devices } from '@/styles/breakpoints';
import { TitleH2 } from '@/styles/typography';

interface IProps {
  tag: string;
  description: string;
  imageSrc: string;
  image: object;
}

export const FeaturesIntro: FC<IProps> = ({
  tag,
  description,
  imageSrc,
  image,
  first_title,
  second_title,
}) => {
  return (
    <SectionWrapper imageSrc={imageSrc}>
      <Overlay>
        <Container>
          <WrapperInner>
            <LabelWrapper>
              <h1>{tag}</h1>
            </LabelWrapper>

            <Title>
              <span className="first_part">{first_title} </span>
              <span className="second_part">{second_title}</span>
            </Title>

            <Description>{description}</Description>
            <Button
              onClick={() =>
                window.open('https://app.orcatec.com/auth/signup', 'e_blank')
              }
              variant="secondary"
            >
              Get Started for Free
            </Button>
          </WrapperInner>
        </Container>
        <Container>
          <ImageWrapper>
            <Image priority={true} src={image} alt="background image" />
          </ImageWrapper>
        </Container>
      </Overlay>
    </SectionWrapper>
  );
};

const SectionWrapper = styled.section<{ imageSrc: string }>`
  position: relative;
  width: 100%;
  height: 608px;
  ${backgroundImageMixin(background.src)};

  @media only screen and ${devices.desktop} {
    height: 834px;
  }
`;

const LabelWrapper = styled.div`
  color: var(--fontColorDarkBlue);
  text-align: left;
  font-family: var(--font-roboto);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 8px;
  @media only screen and ${devices.desktop} {
    text-align: center;
  }
`;

const Overlay = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ImageWrapper = styled.div`
  /* position: absolute;
  bottom: 0; */
  overflow: hidden;
  height: auto;
  /* min-height: 180px; */
  width: 100%;
  & img {
    display: block;
    height: auto;
    width: 100%;
    margin: 0 auto;
  }

  @media only screen and ${devices.desktop} {
    & img {
      /* height: 390px; */

      width: 100%;
      max-width: 929px;
      margin: 0 auto;
    }
  }
`;

const WrapperInner = styled.article`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin: 0 auto;
  padding-top: 30px;
  & button {
    width: 100% !important;
  }
  @media only screen and ${devices.desktop} {
    padding-top: 62px;
    align-items: center;
    max-width: 720px;
    & button {
      width: 180px !important;
      padding: 12px 24px;
    }
  }
`;

const Title = styled(TitleH2)`
  text-align: left;
  margin-bottom: 16px;
  font-size: 32px;
  & .first_part {
    color: var(--darkBlueText);
  }
  & .second_part {
    color: var(--mainBlue);
  }

  @media only screen and ${devices.desktop} {
    line-height: 46px;
    text-align: center;
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 58px;
  }
`;

const Description = styled.p`
  font-family: var(--font-roboto);
  color: var(--fontColorDarkGrey);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 32px;
  @media only screen and ${devices.desktop} {
    text-align: center;
  }
`;
